(() => {
  const start = () => {
    const video = document.querySelector('video[data-sc-hero-video]');
    if (!video || !video.dataset.src || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
    video.addEventListener('playing', () => { video.style.opacity = '1'; }, { once: true });
    video.src = video.dataset.src;
    video.play().catch(() => {});
  };
  const schedule = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
    else setTimeout(start, 0);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
